
export default {
  props: {
    // [{ name, products: [product] }] — already ordered and filtered by the API.
    categories: {
      type: Array,
      default: () => []
    },

    // Every accessory, flat. Used only when there are no categories.
    products: {
      type: Array,
      default: () => []
    },

    // Ids the shopper has already picked, so a collapsed category still says so.
    selectedIds: {
      type: Array,
      default: () => []
    },

    // [{id, count}] carried in from the external configurator's link — the rows
    // it names open showing that quantity instead of one.
    prefilled: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      openIndex: null
    }
  },

  methods: {
    isOpen(index) {
      return this.openIndex === index
    },

    toggle(index) {
      this.openIndex = this.isOpen(index) ? null : index
    },

    getPanelId(index) {
      return `accessories-${this._uid}-${index}`
    },

    getHeaderId(index) {
      return `${this.getPanelId(index)}-header`
    },

    // The counters read as bare numbers ("Bucket & Ladles 4 2 added") to a screen
    // reader, so the button spells them out instead.
    getCategoryLabel(category) {
      const selected = this.getSelectedCount(category)
      const label = `${category.name}, ${category.products.length} accessories`

      return selected ? `${label}, ${selected} added` : label
    },

    isSelected(id) {
      return this.selectedIds.includes(id)
    },

    getSelectedCount(category) {
      return category.products.filter((product) => this.isSelected(product.id)).length
    },

    // 0 when the link didn't name it, which the row reads as "no pre-fill".
    // Trimmed on both sides — these are EBMS ids and some carry padding, so a
    // strict compare would silently fail to pre-fill a row that does exist.
    getPrefilledCount(id) {
      const key = String(id ?? "").trim()

      return this.prefilled.find((entry) => String(entry.id ?? "").trim() === key)?.count || 0
    }
  }
}
